/**
 * Phase 18 — read-only gate for unverified users.
 * Mirrors backend `require_verified` (core/security.py). Admins are exempt.
 */
export const canWrite = (user) => {
  if (!user) return false;
  if (user.is_admin) return true;
  return !!user.email_verified;
};

export const VERIFY_BLOCKED_MESSAGE = 'Please verify your email to perform this action.';
